export default "__VITE_ASSET__DLfMuUiO__"